// Local translations
export const T = {
  en_GB: {
    // Personal Info
    personalInfo: "Personal Information",
    personalInfoDescription: "Update your personal details",
    name: "Name",
    namePlaceholder: "Your name",
    nameRequired: "Name is required",
    ssoNameWarning:
      "Your name comes from your organization's identity provider (SSO). You can change it here, but it will be overwritten the next time you sign in.",
    email: "Email",
    verified: "Verified",
    notVerified: "Not verified",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "+47 123 45 678",
    title: "Title",
    titlePlaceholder: "e.g. Senior Advisor",
    signature: "Signature",
    signaturePlaceholder: "Your signature",
    language: "Language",
    save: "Save",
    profileUpdated: "Saved",
    failedToUpdateProfile: "Failed to update profile",
  },
  nb_NO: {
    // Personal Info
    personalInfo: "Personlig informasjon",
    personalInfoDescription: "Oppdater dine personlige opplysninger",
    name: "Navn",
    namePlaceholder: "Ditt navn",
    nameRequired: "Navn er påkrevd",
    ssoNameWarning:
      "Navnet ditt kommer fra organisasjonens identitetsleverandør (SSO). Du kan endre det her, men det blir overskrevet neste gang du logger inn.",
    email: "E-post",
    verified: "Verifisert",
    notVerified: "Ikke verifisert",
    phoneNumber: "Telefonnummer",
    phoneNumberPlaceholder: "+47 123 45 678",
    title: "Tittel",
    titlePlaceholder: "f.eks. Seniorrådgiver",
    signature: "Signatur",
    signaturePlaceholder: "Din signatur",
    language: "Språk",
    save: "Lagre",
    profileUpdated: "Lagret",
    failedToUpdateProfile: "Kunne ikke oppdatere profilen",
  },
} as const;
